
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { handleError, initClient } from '../../../../../api';
import { formatDateTime } from '../../../../../util';
import { Cell, CellClient, ICostSumup } from '../../../../backend/backendapi';

@Component
export default class TabCost extends Vue {
  @Prop({ required: true })
  readonly cell!: Cell;
  @Prop({ required: true })
  readonly plannedCosts!: ICostSumup;
  @Prop({ required: true })
  readonly unplannedCosts!: ICostSumup;
  @Prop({ required: true })
  readonly correctionCosts!: ICostSumup;

  //api
  readonly cellAPI = initClient(CellClient);

  costCorrectionMinutesInputFloat: number = 0;
  costCorrectionCostInputFloat: number = 0;

  get costCorrectionMinutesInputString() {
    return this.formatNumber(this.costCorrectionMinutesInputFloat, false, 0);
  }

  set costCorrectionMinutesInputString(val: string) {
    this.costCorrectionMinutesInputFloat = this.parseNumber(val);
  }

  get costCorrectionCostInputString() {
    return this.formatNumber(this.costCorrectionCostInputFloat, false, 0);
  }

  set costCorrectionCostInputString(val: string) {
    this.costCorrectionCostInputFloat = this.parseNumber(val);
  }

  formatDateTime = formatDateTime;

  //actions
  addCostCorrection(): void {
    if (!this.cell) {
      return;
    }
    let cellId = this.cell.id;
    this.cellAPI.addCostCorrection(cellId, this.costCorrectionMinutesInputFloat, this.costCorrectionCostInputFloat)
        .then(_ => {
          this.costCorrectionMinutesInputFloat = 0;
          this.costCorrectionCostInputFloat = 0;
          this.cellAPI.getCellCost(cellId, 'correction')
              .then(res => {
                Object.assign(this.correctionCosts!, res.result!);
              })
              .catch(e => handleError(this.$toasted, this.$i18n, e));
          this.$toasted.info(this.$t('txtSaved').toString());
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  //mapper
  formatNumber(v: number, grouping: boolean = true, fracDigits: number = 2): string {
    return v.toLocaleString(this.$i18n.locale, { minimumIntegerDigits: 1, minimumFractionDigits: fracDigits, useGrouping: grouping });
  }

  parseNumber(v: string): number {
    let decimal = this.formatNumber(1.1).substring(1, 2);
    v = v.replace(new RegExp('(?![0-9' + decimal + ']).'), ''); //replace anything not 0-9 and decimal point
    v = v.replace(decimal, '.');
    let ret = parseFloat(v);
    if (ret.toString() === 'NaN') {
      ret = 0;
    }
    return ret;
  }
}
